module.exports = __webpack_public_path__ + "static/media/applestore.d0f173e6.png";